<div class="block-list-games">
    <div class="list-games d-flex flex-column" style="gap: 14px;">
        <!-- <div class="d-flex align-items-center justify-content-between item-room">
            <div class="d-flex align-items-start flex-column gap-2">
                <span class="block-name-game">Test Design 1</span>
                <span class="room-condition open">Відкрита кімната</span>
            </div>
            <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
                <div class="d-flex align-items-center justify-content-end sand-timer">
                    <span class="material-symbols-outlined">hourglass_bottom</span>
                    <span>Очікування гравців</span>
                </div>
                <button type="button" class="d-flex align-items-center justify-content-center item-room-join">
                    <span>Приєднатися</span>
                    <span class="material-symbols-outlined">arrow_right_alt</span>
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between item-room">
            <div class="d-flex align-items-start flex-column gap-2">
                <span class="block-name-game">Test Design 2</span>
                <span class="room-condition close">
                    <span class="material-symbols-outlined">lock</span>
                    <span>Закрита кімната</span>
                </span>
            </div>
            <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
                <div class="d-flex align-items-center justify-content-end sand-timer">
                    <span class="material-symbols-outlined">done_all</span>
                    <span>Кімната заповнена</span>
                </div>
                <button type="button" disabled class="d-flex align-items-center justify-content-center item-room-join">
                    <span>Приєднатися</span>
                    <span class="material-symbols-outlined">arrow_right_alt</span>
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between item-room">
            <div class="d-flex align-items-start flex-column gap-2">
                <span class="block-name-game">Дуже довга назва кімнати Стас 23.09 понеділок</span>
                <span class="room-condition open">Відкрита кімната</span>
            </div>
            <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
                <div class="d-flex align-items-center justify-content-end sand-timer">
                    <span class="material-symbols-outlined">hourglass_bottom</span>
                    <span>Очікування гравців</span>
                </div>
                <button type="button" disabled class="d-flex align-items-center justify-content-center item-room-join">
                    <span>Приєднання</span>
                    <span class="material-symbols-outlined">progress_activity</span>
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between item-room">
            <div class="d-flex align-items-start flex-column" style="gap: 12px;">
                <span class="block-name-game">Test Design 3</span>
                <div class="d-flex align-items-center item-room-code">
                    <mat-form-field appearance="outline" class="input-code-room">
                        <button matTextPrefix matIconButton aria-label="Clear">
                            <mat-icon>lock</mat-icon>
                        </button>
                        <input matInput type="text" placeholder="Введіть пароль">
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
                <div class="d-flex align-items-center justify-content-end sand-timer">
                    <span class="material-symbols-outlined">hourglass_bottom</span>
                    <span>Очікування гравців</span>
                </div>
                <button type="button" class="d-flex align-items-center justify-content-center item-room-join">
                    <span>Приєднатися</span>
                    <span class="material-symbols-outlined">arrow_right_alt</span>
                </button>
            </div>
            <div class="align-items-center justify-content-start is-mobile-show">
                <mat-form-field appearance="outline" class="input-code-room w-100">
                    <button matTextPrefix matIconButton aria-label="Clear">
                        <mat-icon>lock</mat-icon>
                    </button>
                    <input matInput type="text" placeholder="Введіть пароль">
                </mat-form-field>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between item-room">
            <div class="d-flex align-items-start flex-column gap-2">
                <span class="block-name-game">Дуже довга назва кімнати Стас 23.09 понеділок</span>
                <span class="room-condition close">
                    <span class="material-symbols-outlined">lock</span>
                    <span>Гра уже почалась</span>
                </span>
            </div>
            <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
                <div class="d-flex align-items-center justify-content-end sand-timer">
                    <span class="material-symbols-outlined">gamepad</span>
                    <span>Гра триває</span>
                </div>
                <button type="button" disabled class="d-flex align-items-center justify-content-center item-room-join">
                    <span>Приєднання</span>
                    <span class="material-symbols-outlined">progress_activity</span>
                </button>
            </div>
        </div> -->
        @if(game().length) {
            <ng-scrollbar class="settings-scroll" asyncViewport>
                <div class="d-flex flex-column lists-rooms">
                    @for (game of game(); track game) {
                        <app-tmp-game [data]="game"></app-tmp-game>
                    }                
                </div>
            </ng-scrollbar>
        }@else{
            @if(isSearch()){
                <div class="list-empty-search">
                    <div class="d-flex flex-column block-view-info">
                        <img src="./assets/search.png" />
                        <span>{{ 'list.txtNotSearch' | translate }}</span>
                    </div>
                    <div class="d-flex flex-column block-event-info">
                        <div class="line"></div>
                        <div class="d-flex flex-column block-events">
                            <span>{{ 'list.txtOtherValueSearch' | translate }}</span>
                            <button type="button" class="btn-cast" (click)="resetSearch()" [disabled]="isReset">
                                <span>{{ 'buttons.txtCast' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            }@else{
                <div class="list-empty-list">
                    <div class="d-flex flex-column block-view-info">
                        <img src="./assets/fon-empty.png" />
                        <span>{{ 'list.txtNotList' | translate }}</span>
                        <!-- <span style="text-transform: uppercase;">Список ігор порожній</span> -->
                    </div>
                    <div class="d-flex flex-column block-event-info">
                        <div class="line"></div>
                        <div class="d-flex flex-column block-events">
                            <!-- <span>{{ 'list.txtAnotherOption' | translate }}</span> -->
                            <button type="button" class="btn-cast" (click)="updateList()" [disabled]="isReset">
                                <span>{{ 'buttons.txtRefreshList' | translate }}</span>
                                <span class="material-symbols-outlined">refresh</span>
                            </button>
                        </div>
                    </div>
                </div>
            }            
            
        }
    </div>
</div>